import React from 'react'
import { TopBarMenuItem } from 'app/menu/components/TopBarV1/TopBarMenuItem'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { getOrderOrWorkorderLines } from 'app/shops/state/selectors'
import { useSelector } from 'react-redux'

export const CartMenu: React.FC = () => {
  const lines = useSelector(getOrderOrWorkorderLines)
  return (
    <TopBarMenuItem
      badge={0}
      startIcon={
        <Box sx={{ display: 'flex', alignItems: 'center' }} data-testid='topbar-cart-menu'>
          <Typography variant='caption' sx={{ mr: 0.5 }}>
            {lines.length}&nbsp;
          </Typography>
          <ShoppingCartOutlinedIcon />
        </Box>
      }
    />
  )
}
